import { render, staticRenderFns } from "./VBarHandleRight.vue?vue&type=template&id=4e7b28f2&scoped=true&"
import script from "./VBarHandleRight.vue?vue&type=script&lang=js&"
export * from "./VBarHandleRight.vue?vue&type=script&lang=js&"
import style0 from "./VBarHandleRight.vue?vue&type=style&index=0&id=4e7b28f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7b28f2",
  null
  
)

export default component.exports